$(function() {
	/** Prevents users from accidentally submitting form with enter key */
	$(document).on('keyup keypress', "form input[type='text']", function(e) {
		/* enterkey & enter on numpad */
		if (e.keyCode === 13 || e.keyCode === 169) {
			e.preventDefault();
		}
	});

	// Carousel d'écran sur la main page
	var screenshots = document.querySelectorAll('.screen-content-item');
	if (screenshots.length) {
		var nextScreen = function() {
			var current = document.querySelector('.screen-content-item.current');
			var currentIndex = [...screenshots].indexOf(current);
			currentIndex = (currentIndex + 1) % screenshots.length;
			current.classList.remove('current');
			screenshots[currentIndex].classList.add('current');
		};
		var screenLoop = function() {
			nextScreen();
			setTimeout(screenLoop, 5000);
		};
		setTimeout(screenLoop, 3000);
	}

	// ----------------------------------------------------------------------
	// Accordion
	// ----------------------------------------------------------------------

	// masque tous les containers
	$('.acc-container').hide();

	$(document).on('click', '.acc-trigger', function(e) {
		var $trigger = $(this);
		var $content = $trigger.next();

		if ($content.is(':hidden')) {
			$trigger.closest('.accrodation').find('.acc-trigger.active').removeClass('active').next().slideUp(300);
			$trigger.toggleClass('active');
			$content.slideDown(300);
		} else {
			$trigger.removeClass('active');
			$content.slideUp(300);
		}
		e.preventDefault();
	});

	/*
	 * Cette adresse email est protégée contre les robots des spammeurs, vous
	 * devez activer Javascript pour la voir.
	 */
	function courmail1(v) {
		var addy45633;
		switch (v) {
			case 'sc':
				addy45633 = 'S&#101;rv&#105;c&#101;.Cl&#105;&#101;nts';
				break;
			case 'su':
				addy45633 = 's&#117;pp&#111;rt';
				break;
			case 'sj':
				addy45633 = 's&#101;rv&#105;c&#101;.j&#117;r&#105;d&#105;q&#117;&#101;';
				break;
			case 'co':
				addy45633 = 'c&#111;nt&#97;ct';
				break;
			default:
				return;
		}
		addy45633 = addy45633 + '&#64;';
		addy45633 = addy45633 + 't&#105;m&#101;p&#101;rf&#111;rm&#97;nc&#101;' + '&#46;' + 'c&#111;m';
		return addy45633;
	}

	function courmail(v) {
		var prefix = 'm&#97;&#105;lt&#111;:';
		var suffix = '';
		var attribs = '';
		var path = 'hr' + 'ef' + '=';
		var addy45633 = courmail1(v);
		return '<a ' + path + '\'' + prefix + addy45633 + suffix + '\'' + attribs + '>' + addy45633 + '</a>';
	}

	$("span.email").each(function() {
		var $this = $(this);
		$this.html(courmail($this.data('email')));
	});

	// //////////////////////////////////////////////////////////////////////
	// scroll up
	$(window).scroll(function() {
		if ($(this).scrollTop() > 100) {
			$('.scrollup').fadeIn();
		} else {
			$('.scrollup').fadeOut();
		}
	});

	$('.scrollup').click(function() {
		$("html, body").animate({ scrollTop: 0 }, 500);
		return false;
	});

	// //////////////////////////////////////////////////////////////////////
	// jquery jcarousel (bidouille en fonction de la taille de l'écran)

	$('div.clients_carousel div.jcarousel').each(function() {
		var carousel = $(this);
		var width = carousel.innerWidth();

		var scroll = 1;
		if (width >= 900) {
			scroll = 4;
		} else if (width >= 600) {
			scroll = 3;
		} else if (width >= 350) {
			scroll = 2;
		}

		// -20 pour la marge
		width -= (scroll - 1) * 20 / scroll;

		width = Math.floor(width / scroll);

		carousel.find('li').css('width', width + 'px');
		carousel.jcarousel({ scroll: scroll });
	});

	$('div.screenshots_carousel div.jcarousel').each(function() {
		function computeCss(width) {
			return {
				width: width + 'px',
				height: Math.round(258 * width / 340) + 'px'
			};
		}

		var carousel = $(this);
		var width = carousel.innerWidth();

		var scroll = 1;
		if (width >= 600) {
			scroll = 3;
		} else if (width >= 350) {
			scroll = 2;
		}

		// -20 pour la marge
		width -= (scroll - 1) * 20 / scroll;

		width = Math.floor(width / scroll);

		carousel.find('li').css(computeCss(width));
		carousel.jcarousel({ scroll: scroll });
		carousel.css('height', computeCss(width).height);
	});

	// //////////////////////////////////////////////////////////////////////
	/* Simple image gallery. Uses default settings */
	$('.fancybox').fancybox();

	// //////////////////////////////////////////////////////////////////////
	/* Calculateur de prix */
	function formatPerMonth(value) {
		return value ? value.toFixed(2) + ' &euro; par mois' : '';
	}

	function annualSubPrice(count) {

		if (count < 10)
			return count * 178.8;
		else if (count < 20)
			return count * 160.92;
		else if (count < 30)
			return count * 151.98;
		else if (count < 40)
			return count * 143.04;
		else if (count <= 50)
			return count * 134.10;

		return annualSubPrice(50) + (count - 50) * 89.40;
	}

	$("#count").on('keyup', function() {
		var value = this.value;
		try {
			value = parseInt(value);
		} catch (ex) {
			value = 0;
		}

		if (value < 1) value = 0;

		var monthSubTarif = value * 19.5;
		var annualSubTarif = annualSubPrice(value);
		var annualSubTarifPerMonth = annualSubTarif / 12.0;

		$('#monthlySub').html(formatPerMonth(monthSubTarif));
		$('#annualSub').html(formatPerMonth(annualSubTarifPerMonth));
		$('#annualSubEco').html(monthSubTarif ? ((annualSubTarifPerMonth - monthSubTarif) / monthSubTarif * 100).toFixed(0) + '%' : '');
	}).trigger('keyup');

	$(document).on('click', 'a.training-desc-toggle', function() {
		$('div.training-desc').slideToggle();
		return false;
	});

});
